import React from 'react';
import preview from './leads-preview.png';
import guide from './guide-how-website-visitor-works.png';
import user from './user.png';
import styles from './HowXRayWorksVersionB.module.css';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import classNames from 'classnames';
import moment from 'moment';
import { WebsiteScreenshot } from '../WebsiteScreenshot/WebsiteScreenshot';

export const HowXRayWorksVersionB = ({
  websiteURL,
  currentTraffic,
  additionalLeads,
  onClick,
  src,
  canResolveDomain,
}: {
  websiteURL: string;
  currentTraffic: number;
  additionalLeads: number;
  onClick: () => void;
  src: string;
  canResolveDomain?: boolean;
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.titleBold}>How Does it work?</div>
        <div>
          Customers.ai X-Ray tool automatically captures emails from{' '}
          <span className={styles.website}>{websiteURL}</span> website traffic.
        </div>
      </div>
      <div className={styles.guide}>
        <div
          className={classNames(
            styles.block,
            styles.gap24,
            styles.guideDescription,
          )}
        >
          <div
            className={classNames(styles.block, styles.gap8, styles.alignStart)}
          >
            <div className={styles.mediumTitle}>
              Capture leads{' '}
              <span className={styles.highlighted}>
                without popups or widgets.
              </span>{' '}
              <br />
              100% hands off email capture.
            </div>
            <div className={styles.text}>
              Our partner opt-in network tracks and identifies the emails and
              contact information of 250 Million users in North America.
              <br />
              <br />
              By matching IP’s, devices, and cookies to users we are able to
              identify 15-20% of your anonymous website traffic confidently and
              provide you with an email & contact information.{' '}
            </div>
          </div>
          <PrimaryButton className={styles.primaryButton} onClick={onClick}>
            Get Started
          </PrimaryButton>
        </div>
        <div className={styles.guideWrapper}>
          <div className={styles.screenshotStep}>
            <div className={styles.step}>
              Step 1.
              <div className={styles.timestamp}>
                Anonymous user landed on your website at{' '}
                {moment().format('h:mm a')} {moment().format('MMMM Do')}
              </div>
            </div>
            <WebsiteScreenshot
              canResolve={canResolveDomain}
              websiteURL={websiteURL}
              src={src}
              css={{
                container: styles.screenshotContainer,
                image: styles.screenshotImage,
              }}
            />
            <img src={user} className={styles.userIcon} />
          </div>

          <img src={guide} className={styles.image} />
        </div>
      </div>

      <div className={classNames(styles.block, styles.preview)}>
        <div className={styles.title}>
          <div className={styles.titleBold}>
            Your website traffic visitor list{' '}
          </div>
          Here is a preview of what your anonymous website visitor contact list
          would look like every month!
        </div>
        <div>
          <img src={preview} className={styles.image} />
        </div>
        <div
          className={classNames(styles.block, styles.gap16, styles.footerBlock)}
        >
          <div className={styles.description}>
            Based on our analysis, your site has{' '}
            {currentTraffic.toLocaleString('en-US')} visitors per month we could
            capture an{' '}
            <span className={styles.bold700}>
              additional {Math.ceil(additionalLeads).toLocaleString('en-US')}{' '}
              email
            </span>{' '}
            contacts per month from this traffic.
          </div>
          <PrimaryButton className={styles.primaryButton} onClick={onClick}>
            Get Started
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
